import { render, staticRenderFns } from "./CetakKartu.vue?vue&type=template&id=74d40b85&"
import script from "./CetakKartu.vue?vue&type=script&lang=js&"
export * from "./CetakKartu.vue?vue&type=script&lang=js&"
import style0 from "./CetakKartu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports